export default {
  admin: () => import("/codebuild/output/src1332377934/src/layouts/admin.vue").then(m => m.default || m),
  default: () => import("/codebuild/output/src1332377934/src/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/codebuild/output/src1332377934/src/layouts/empty.vue").then(m => m.default || m),
  static: () => import("/codebuild/output/src1332377934/src/layouts/static.vue").then(m => m.default || m),
  unauthorized: () => import("/codebuild/output/src1332377934/src/layouts/unauthorized.vue").then(m => m.default || m)
}